import { useSupplierOrderList } from "../../../../hooks/api/v2/order/useSupplierOrderList";
import { RequestedOrdersList } from "./RequestedOrdersList";

export const SupplierRequestedOrderList = ({
  selectedOrderId,
}: {
  selectedOrderId: number | null;
}) => {
  const query = useSupplierOrderList({
    limit: 20,
    query: [
      {
        type: "acceptedAt",
        modifier: "IS_NULL",
      },
      {
        type: "cancelledAt",
        modifier: "IS_NULL",
      },
      {
        type: "deniedAt",
        modifier: "IS_NULL",
      },
    ],
  });
  return (
    <RequestedOrdersList query={query} selectedOrderId={selectedOrderId} />
  );
};
